<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">岗亭名称：</span>
        </div>
        <el-input v-model="formData.sentryBoxName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">姓名：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">手机号：</span>
        </div>
        <el-input v-model="formData.phone" size="small" style="width: 280px" />
        <span style="color: #999999; font-size: 12px;">用于账号登录岗亭平台</span>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">密码：</span>
        </div>
        <el-input v-model="formData.password" type="password" size="small" style="width: 280px" />
        <span style="color: #999999; font-size: 12px;">请输入8至20位无特殊字符的密码</span>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">确认密码：</span>
        </div>
        <el-input v-model="formData.confirmPassword" type="password" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">进相机：</span>
        </div>
        <el-select v-model="formData.inDeviceCode" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in inDeviceList"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">出相机：</span>
        </div>
        <el-select v-model="formData.outDeviceCode" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in outDeviceList"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">ip地址：</span>
        </div>
        <div style="display: flex;justify-content: flex-start;align-items: flex-start;flex-direction: column;">
          <div v-for="(item, index) in ipsList" :key="index" style="margin-bottom: 10px;">
            <el-input v-model="ipsList[index]" size="small" style="width: 280px" />
            <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeIps(index)" v-if="index > 0"></i>
            <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addIps(index)" v-if="index === ipsList.length - 1 &&index<2"></i>
          </div>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import md5 from "js-md5";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/ParkingService";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "account-modify",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "岗亭账号管理"
        }
      ],
      mainTitle: "修改账户",
      subheading: "",

      inDeviceList: [],
      outDeviceList: [],
      formData: {
        code: "",
        sentryBoxName: "",
        name: "",
        phone: "",
        password: "",
        confirmPassword: "",
        inDeviceCode: "",
        inDeviceName: "",
        outDeviceCode: "",
        outDeviceName: "",
        memo: ""
      },
      ipsList: []
    };
  },
  created() {
    this.formData.code = this.$route.params.id;
    this.getInDeviceList();
    this.getOutDeviceList();
    this.getParkingAccountByCode();
  },
  methods: {
    toSentryBoxMangePage() {
      this.$router.push({
        name: "sentry-box-manage"
      });
    },

    // 获取进相机列表
    getInDeviceList() {
      this.$axios
        .post(api.getParkingDeviceList, {
          passType: "1"
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.inDeviceList = data;
          }
        })
        .catch(errorHandler("获取相机列表失败"));
    },

    // 获取进相机列表
    getOutDeviceList() {
      this.$axios
        .post(api.getParkingDeviceList, {
          passType: "2"
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.outDeviceList = data;
          }
        })
        .catch(errorHandler("获取相机列表失败"));
    },

    // 获取单个账号信息
    getParkingAccountByCode() {
      this.$axios
        .get(`${api.getParkingAccountByCode}/${this.$route.params.id}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.password = "";
            data.confirmPassword = "";
            let ipsList = res.data.data.ips || '';
            this.formData = res.data.data;
            this.ipsList = ipsList.split(",");
          }
        })
        .catch(errorHandler("获取信息失败"));
    },

    confirm() {
      let ips = "";
      for (var i = 0; i < this.ipsList.length; i++) {
        ips += this.ipsList[i];
        if (i != this.ipsList.length - 1) {
          ips += ",";
        }
      }
      this.formData.ips = ips;
      let checkName = pattern.characterInput_24.test(this.formData.name);
      let checkPassword = pattern.password.test(this.formData.password);
      let checkPhone = pattern.phone.test(this.formData.phone);
      if (!this.formData.sentryBoxName) {
        nError("请输入岗亭名称");
        return false;
      }
      if (!this.formData.name) {
        nError("请输入姓名");
        return false;
      } else {
        if (!checkName) {
          nError("姓名不允许有特殊字符或空格");
          return false;
        }
      }
      if (!this.formData.password) {
        nError("请输入密码");
        return false;
      } else {
        if (!checkPassword) {
          nError("密码不允许有特殊字符或中文");
          return false;
        }
      }
      if (!this.formData.confirmPassword) {
        nError("请确认密码");
        return false;
      }
      if (!this.formData.phone) {
        nError("请输入联系人手机");
        return false;
      } else {
        if (!checkPhone) {
          nError("联系人手机格式不正确");
          return false;
        }
      }
      if (this.formData.password !== this.formData.confirmPassword) {
        nError("两次密码不一致");
        return false;
      }
      if (!this.formData.inDeviceCode) {
        nError("请选择进相机");
        return false;
      }
      if (!this.formData.outDeviceCode) {
        nError("请选择出相机");
        return false;
      }
      this.inDeviceList.map(v => {
        if (v.code === this.formData.inDeviceCode) {
          this.formData.inDeviceName = v.name;
        }
      });
      this.outDeviceList.map(v => {
        if (v.code === this.formData.outDeviceCode) {
          this.formData.outDeviceName = v.name;
        }
      });
      let name = this.formData.phone.toLowerCase();
      let pw = this.formData.password + name;
      let once = md5(pw) + name;
      let pwd;
      for (let i = 0; i < 9; i++) {
        pwd = md5(once);
        once = pwd + name;
      }
      let reqData = {
        code: this.formData.code,
        sentryBoxName: this.formData.sentryBoxName,
        name: this.formData.name,
        phone: this.formData.phone,
        password: pwd,
        inDeviceCode: this.formData.inDeviceCode,
        inDeviceName: this.formData.inDeviceName,
        outDeviceCode: this.formData.outDeviceCode,
        outDeviceName: this.formData.outDeviceName,
        memo: this.formData.memo,
        ips: this.formData.ips
      };
      this.$axios
        .post(api.updateParkingAccount, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.toSentryBoxMangePage();
          }
        })
        .catch(errorHandler("修改失败"));
    },
    cancel() {
      this.toSentryBoxMangePage();
    },

    addIps(index) {
      if (!this.ipsList[index]) {
        nError("请先输入当前ip地址");
        return false;
      }
      let obj = "";
      this.ipsList.push(obj);
    },

    removeIps(index) {
      this.ipsList.splice(index, 1);
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
  vertical-align: -webkit-baseline-middle;
}
.form-line {
  margin: 20px 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.dialogLine {
  width: 60%;
  margin: 20px auto;
  display: flex;
  justify-content: center;
}
.dialogLine div {
  min-width: 80px;
  text-align: right;
  margin-right: 10px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/SentryBox/SentryBoxModify.vue